import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import messages from '../../messages';

const updateJobAutoTransfer = async ({
  uuid,
  autoTransfer,
}: {
  uuid: string;
  autoTransfer: boolean;
}) => {
  const payload = {
    data: {
      type: 'jobs',
      uuid,
    },
  };

  const action = autoTransfer
    ? 'enable_auto_transfer'
    : 'disable_auto_transfer';

  const { data } = await putRequest<RequestSimplifiedData>(
    `${API.PUT.updateJob(uuid)}/${action}`,
    payload,
  );

  return data;
};

export const useUpdateJobAutoTransfer = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateJobAutoTransfer,
    onSuccess: (_, { autoTransfer }) => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.JOBS] });
      handleSuccess(
        autoTransfer
          ? formatMessage(messages.autoTransferEnabled)
          : formatMessage(messages.autoTransferDisabled),
      );
    },
    onError: handleError,
  });
};
